export enum Transition {
  Enter,
  Exit,
}
